/* eslint-disable */
const OnePageAjax = el => {
    const datas = [];
    const links = document.querySelectorAll('.deepLink');
    const body = document.body;
    const data_scroll_content = document.querySelector('[data-scroll-content]');
    const slugify = value => value.replace(/\/?$/, '/');

    links.forEach(link => datas.push({
        href: slugify(link.getAttribute('href')),
        id: link.dataset.page_id
    }));

    const page = slug => {
        if (slug == '/' || slug == '/en/') {
            document.querySelectorAll('.subpage').forEach(page => close(page));
        } else {
            for (let data of datas) data.href == slug && ajax(`?page_id=${data.id}`);
        }
    };

    window.onpopstate = () => page(document.location.pathname);

    links.forEach(link => {
        link.onclick = e => {
            e.preventDefault();
            const href = slugify(link.getAttribute('href'));
            const name = href.substr(1);
            page(href);
            window.history.pushState(name, name, href);
        };
    });

    const open = response => {
        const scroll_width = window.innerWidth - document.documentElement.clientWidth;
        body.classList.add('hasPopin');
        body.style.marginRight = `${scroll_width}px`;
        data_scroll_content.style.marginRight = `${scroll_width}px`;
        const subpage = document.createElement('div');
        subpage.innerHTML = response;
        subpage.className = 'subpage';
        body.appendChild(subpage);
        subpage.querySelector('.btn-back').onclick = () => window.history.back();
        subpage.addEventListener('animationend', () => {
            subpage.classList.add('show');
        }, {once: true});
    };

    const close = (subpage) => {
        subpage.classList.add('hide');
        subpage.addEventListener('animationend', () => {
            body.classList.remove('hasPopin');
            body.style.marginRight = '0px';
            data_scroll_content.style.marginRight = '0px';
            subpage.remove();
        }, {once: true});
    };

    const ajax = url => {
        body.classList.add('loading');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
                open(xhr.response);
            }
            body.classList.remove('loading');
        };
        xhr.send();
    };

    page(document.location.pathname);
};

OnePageAjax();
